import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useModuleIds } from 'portal/lib/hooks'
import { alertRulesLoad } from 'portal/store/projectAlertRules/actions'

export const useAlertRulesLoader = projectId => {
  const dispatch = useDispatch()
  const { accountId } = useModuleIds()

  const reload = useCallback(() => {
    if (!accountId || !projectId) {
      return
    }
    dispatch(alertRulesLoad(accountId, projectId))
  }, [dispatch, accountId, projectId])

  useEffect(() => {
    reload()
  }, [reload])

  const { loading, error, items } = useSelector((state: any) => {
    return state.alertRules
  })

  return {
    loading,
    error,
    items,
    reload
  }
}
